import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import ApprovalRequestLog from './approval-request-log-model'
import {
  CreateApprovalRequestLogAsync,
  DeleteApprovalRequestLogAsync,
  LoadApprovalRequestLogsAsync,
} from './approvalRequestLog-thunk'
const initialState: approvalRequestLogSliceState = {
  approvalRequestLog: [],
  selected_approvalRequestLog: '',
  is_loading_approvalRequestLog: false,
  is_creating_approvalRequestLog: false,
  is_deleting_approvalRequestLog: false,
}
export interface approvalRequestLogSliceState {
  approvalRequestLog: ApprovalRequestLog[]
  selected_approvalRequestLog?: string
  is_loading_approvalRequestLog: boolean
  is_creating_approvalRequestLog: boolean
  is_deleting_approvalRequestLog: boolean
}
export const approvalRequestLogSlice = createSlice({
  name: 'approvalRequestLog',
  initialState,
  reducers: {
    setSelectedapprovalRequestLog: (state, action) => {
      state.selected_approvalRequestLog = action.payload
    },
    clearStateapprovalRequestLog: (state) => {
      state.approvalRequestLog = []
      state.is_loading_approvalRequestLog = false
      state.is_creating_approvalRequestLog = false
      state.is_deleting_approvalRequestLog = false
    },
    mergeapprovalRequestLog: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_approvalRequestLog = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.approvalRequestLog = merge(
            state.approvalRequestLog,
            payload,
          ) as any
        }
      }
    },

    add_approvalRequestLog: (state, action) => {
      if (action.payload) {
        state.approvalRequestLog = [...state.approvalRequestLog, action.payload]
      }
    },
    set_approvalRequestLog: (state, action) => {
      let { key, value, id } = action.payload
      state.approvalRequestLog = state.approvalRequestLog.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadApprovalRequestLogsAsync.pending, (state) => {
      state.is_loading_approvalRequestLog = true
    })
    builder.addCase(LoadApprovalRequestLogsAsync.fulfilled, (state, action) => {
      state.is_loading_approvalRequestLog = false
      if (action.payload) {
        state.approvalRequestLog = action.payload
      }
    })
    builder.addCase(LoadApprovalRequestLogsAsync.rejected, (state) => {
      state.is_loading_approvalRequestLog = false
    })
    builder.addCase(CreateApprovalRequestLogAsync.pending, (state) => {
      state.is_creating_approvalRequestLog = true
    })
    builder.addCase(CreateApprovalRequestLogAsync.fulfilled, (state) => {
      state.is_creating_approvalRequestLog = false
    })
    builder.addCase(CreateApprovalRequestLogAsync.rejected, (state) => {
      state.is_creating_approvalRequestLog = false
    })
    builder.addCase(DeleteApprovalRequestLogAsync.pending, (state) => {
      state.is_deleting_approvalRequestLog = true
    })
    builder.addCase(
      DeleteApprovalRequestLogAsync.fulfilled,
      (state, action) => {
        state.is_deleting_approvalRequestLog = false
        if (state.approvalRequestLog) {
          state.approvalRequestLog = state.approvalRequestLog.filter(
            (x) => action.payload.id !== x.id,
          )
        }
      },
    )
    builder.addCase(DeleteApprovalRequestLogAsync.rejected, (state) => {
      state.is_deleting_approvalRequestLog = false
    })
  },
})

export const {
  clearStateapprovalRequestLog,
  setSelectedapprovalRequestLog,
  set_approvalRequestLog,
  mergeapprovalRequestLog,
  add_approvalRequestLog,
} = approvalRequestLogSlice.actions

export const get_approvalRequestLog =
  (id?: string) =>
  (state: {
    approvalRequestLog: {
      approvalRequestLog: ApprovalRequestLog[]
    }
  }): ApprovalRequestLog | null => {
    let temp = state?.approvalRequestLog?.approvalRequestLog?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.approvalRequestLog?.approvalRequestLog[0] || null
  }
export const get_selected_approvalRequestLog = (state: {
  approvalRequestLog: approvalRequestLogSliceState
}): ApprovalRequestLog | null => {
  let id = state?.approvalRequestLog?.selected_approvalRequestLog
  let temp = state?.approvalRequestLog?.approvalRequestLog?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_approvalRequestLog = (state: {
  approvalRequestLog: {
    approvalRequestLog: ApprovalRequestLog[]
  }
}): ApprovalRequestLog[] => {
  let temp = state?.approvalRequestLog?.approvalRequestLog
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_approvalRequestLog_busy = (state: {
  approvalRequestLog: approvalRequestLogSliceState
}) => {
  return (
    state?.approvalRequestLog.is_deleting_approvalRequestLog ||
    state?.approvalRequestLog.is_loading_approvalRequestLog ||
    state?.approvalRequestLog.is_creating_approvalRequestLog
  )
}
export const is_deleting_approvalRequestLog_busy = (state: {
  approvalRequestLog: approvalRequestLogSliceState
}) => {
  return state?.approvalRequestLog.is_deleting_approvalRequestLog
}
export const is_loading_approvalRequestLog_busy = (state: {
  approvalRequestLog: approvalRequestLogSliceState
}) => {
  return state?.approvalRequestLog.is_loading_approvalRequestLog
}
export const is_creating_approvalRequestLog_busy = (state: {
  approvalRequestLog: approvalRequestLogSliceState
}) => {
  return state?.approvalRequestLog.is_creating_approvalRequestLog
}

export default approvalRequestLogSlice.reducer
